// extracted by mini-css-extract-plugin
export default {"centered":"AboutSection_centered__i0PLV","aboutImage":"AboutSection_aboutImage__oa9Sf","note":"AboutSection_note__-MrC9","backButton":"AboutSection_backButton__PSJ1e"};